import React from "react";
import "./AboutUsBannerComp.scss";
export default function AboutUsBannerComp({ text }) {
  return (
    <div className="about-us-comp-cover">
      <div className="banner-text">{text}</div>
    </div>
  );
}
